/*
 * @创建文件时间: 2020-04-10 20:56:02
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-22 11:33:44
 * @联系Qq:1360484677
 * @文件介绍: 养护决策
 */
export default [{
    path: 'pmdBridgeModel',
    name: 'pmdBridgeModel',
    meta: {
        title: '桥梁模型库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdBridgeModel')
}, {
    path: 'pmdRsModel',
    name: 'pmdRsModel',
    meta: {
        title: '路面衰变预估模型库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdRsModel')
}, {
    path: 'pmdTunnelModel',
    name: 'pmdTunnelModel',
    meta: {
        title: '隧道模型库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdTunnelModel')
}, {
    path: 'pmdBridgeChange',
    name: 'pmdBridgeChange',
    meta: {
        title: '桥梁模型校正',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdBridgeChange')
}, {
    path: 'pmdRsChange',
    name: 'pmdRsChange',
    meta: {
        title: '路面模型校正',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdRsChange')
}, {
    path: 'pmdTunnelChange',
    name: 'pmdTunnelChange',
    meta: {
        title: '隧道模型校正',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/modelLibrary/pmdTunnelChange')
}, {
    path: 'pmdRsMeasure',
    name: 'pmdRsMeasure',
    meta: {
        title: '预防性养护默认措施库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/measuresLibrary/pmdRsMeasure')
}, {
    path: 'pmdBridgeMeasure',
    name: 'pmdBridgeMeasure',
    meta: {
        title: '桥梁养护措施库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/measuresLibrary/pmdBridgeMeasure')
}, {
    path: 'pmdTunnelMeasure',
    name: 'pmdTunnelMeasure',
    meta: {
        title: '隧道养护措施库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/measuresLibrary/pmdTunnelMeasure')
}, {
    path: 'pmdCmiCoefficient',
    name: 'pmdCmiCoefficient',
    meta: {
        title: '日常养护指标调整系数表',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/unitPriceLibrary/pmdCmiCoefficient')
}, {
    path: 'pmdDmciBenchmark',
    name: 'pmdDmciBenchmark',
    meta: {
        title: '日常养护费用指标基准表',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/unitPriceLibrary/pmdDmciBenchmark')
}, {
    path: 'pmdDmUnitPriceLibrary',
    name: 'pmdDmUnitPriceLibrary',
    meta: {
        title: '日常养护单价库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/unitPriceLibrary/pmdDmUnitPriceLibrary')
}, {
    path: 'pmdMmeQuota',
    name: 'pmdMmeQuota',
    meta: {
        title: '小修保养工程定额库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/unitPriceLibrary/pmdMmeQuota')
}, {
    path: 'pmdOeUnitPriceLibrary',
    name: 'pmdOeUnitPriceLibrary',
    meta: {
        title: '其余工程养护单价库',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/unitPriceLibrary/pmdOeUnitPriceLibrary')
}, {
    path: 'pmdSectionMaintenance',
    name: 'pmdSectionMaintenance',
    meta: {
        title: '路段划分方法',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdSectionMaintenance')
}, {
    path: 'pmdBridgeMaintenance',
    name: 'pmdBridgeMaintenance',
    meta: {
        title: '桥梁分类养护方法',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdBridgeMaintenance')
}, {
    path: 'pmdTunnelMaintenance',
    name: 'pmdTunnelMaintenance',
    meta: {
        title: '隧道分类养护方法',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdTunnelMaintenance')
}, {
    path: 'pmdPmPitchMeasure',
    name: 'pmdPmPitchMeasure',
    meta: {
        title: '沥青预防性养护措施初选',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmPitchMeasure')
}, {
    path: 'pmdPmCementMeasure',
    name: 'pmdPmCementMeasure',
    meta: {
        title: '水泥预防性养护措施初选',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmCementMeasure')
}, {
    path: 'pmdPmSandMeasure',
    name: 'pmdPmSandMeasure',
    meta: {
        title: '砂石预防性养护措施初选',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmSandMeasure')
}, {
    path: 'pmdPmMeasureF',
    name: 'pmdPmMeasureF',
    meta: {
        title: '措施的使用寿命与单位费用范围',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmMeasureF')
}, {
    path: 'pmdPmIfw',
    name: 'pmdPmIfw',
    meta: {
        title: '不同等级公路的影响因素权重系数',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmIfw')
}, {
    path: 'pmdPmAttributeScore',
    name: 'pmdPmAttributeScore',
    meta: {
        title: '常用预防性养护措施的属性分值',
        auth: true
    },
    component: () =>
        import ('@/views/decisionBase/parametersLibrary/pmdPmAttributeScore')
}]